import Api from "./Api";

export default {
  // orders
  sendNewOrder(obj) {
    return Api().post("job/send-new-order", { order: obj });
  },
  updateOrder(obj) {
    return Api().post("job/update-order", { order: obj });
  },
  getOrder(obj) {
    return Api().post("get-order", obj);
  },
  getOrders() {
    return Api().get("get-orders");
  },

  // cart
  updateItemCart(obj) {
    return Api().post("update-item-cart", obj);
  },
  clearItemsCart(obj) {
    return Api().post("clear-items-cart", obj);
  },
  removeItemCart(obj) {
    return Api().post("remove-item-cart", obj);
  },
  addItemToCart(obj) {
    return Api().post("add-item-cart", obj);
  },

  // invoices
  getInvoice(obj) {
    return Api().post("get-invoice", obj);
  },
  getInvoices(obj) {
    return Api().get("get-invoices", obj);
  },
  updateInvoice(obj) {
    return Api().post("update-invoices", obj);
  },
  getInvoicePdf(obj) {
    return Api().post("get-invoice-pdf", obj);
  },
  getFinancePdf(obj) {
    return Api().post("job/get-finance-pdf", obj);
  },
};
